export default "__VITE_ASSET__CQBjTZhP__"